import InlineLoading from '@apparel/apparel/src/Components/InlineLoading';
import { checkWholesalerDomain, getSubdomainData } from '@apparel/apparel/src/lib/utils';
import GameBreaker from '@apparel/core/arts/logo/gamebreaker_white.png';
import { SupportedCompanies } from '@apparel/core/platform';
import React, { CSSProperties } from 'react';
import { usePlatform } from '../platform/usePlatform';
import { ApparelLogo } from './ApparelLogo';

interface LogoProps {
    color?: string;
    circleColor?: string;
    infinityColor1?: string;
    infinityColor2?: string;
    height?: number;
    hideLetters?: boolean;
    hideShadow?: boolean;
    alt?: string;
    variant?: 'default' | 'simple';
    className?: string;
    style?: CSSProperties;
    forceVariant?: SupportedCompanies;
}

export function Logo({
    color,
    circleColor,
    infinityColor1,
    infinityColor2,
    hideLetters,
    hideShadow,
    alt,
    variant,
    forceVariant,
    ...rest
}: LogoProps) {
    const platform = usePlatform();
    if (platform.getCompany() === SupportedCompanies.GAMEBREAKER) {
        const hostCheck = checkWholesalerDomain();
        const subdomainData = getSubdomainData();
        if (!hostCheck.isGB && !subdomainData.logo) {
            return <InlineLoading />;
        }
        return <img src={subdomainData?.logo || GameBreaker} alt={alt || 'GameBreaker'} {...rest} />;
    }

    return (
        <ApparelLogo
            color={color}
            circleColor={circleColor}
            infinityColor1={infinityColor1}
            infinityColor2={infinityColor2}
            hideLetters={hideLetters}
            hideShadow={hideShadow}
            alt={alt}
            variant={variant}
            {...rest}
        />
    );
}

export default Logo;
